/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2023 Deere & Company

import './duplicate-pin-plate-result.scss';
import React, { Component } from 'react';
import Attachments from './attachment';
import DuplicatePinPlateView from '../state/duplicate-pin-plate-view';
import { FormattedMessage } from 'react-intl';
import LabeledString from '../../../sharedmodules/components/labeled-string';
import PropTypes from 'prop-types';
import { buildDate } from '../../../sharedmodules/services/build-date';
import { buildDealer } from '../../../sharedmodules/services/build-dealer';

class DuplicatePinPlateResult extends Component {

    constructor() {

        super();
        this.handleAccept = this.handleAccept.bind(this);
        this.handleDecline = this.handleDecline.bind(this);
        this.handleComplete = this.handleComplete.bind(this);

    }

    handleAccept() {

        const pinPlate = { ...this.props.duplicatePlate };

        pinPlate.status = 'RETURNED';

        this.props.actions.updateDuplicatePinPlateStatus(this.props.auth.getAccessToken, pinPlate);

    }

    handleDecline() {

        const pinPlate = { ...this.props.duplicatePlate };

        pinPlate.status = 'REJECTED';

        this.props.actions.updateDuplicatePinPlateStatus(this.props.auth.getAccessToken, pinPlate);

    }

    handleComplete() {

        const pinPlate = { ...this.props.duplicatePlate };

        pinPlate.status = 'SUBMITTED';

        this.props.actions.updateDuplicatePinPlateStatus(this.props.auth.getAccessToken, pinPlate);

    }

    render() {

        return (
            <section className="duplicate-pin-plate-result">
                <header>
                    <section className="product-title">
                        <span>
                            <FormattedMessage
                                id={this.props.duplicatePlate.pin}
                            />
                        </span>

                    </section>
                </header>
                <div className="spa-details">
                    <div className="row">
                        <LabeledString
                            className="reference1"
                            data={this.props.duplicatePlate.machineModel}
                            label="MACHINE_MODEL_TYPE"
                        />
                        <LabeledString
                            className="pin"
                            data={this.props.duplicatePlate.pin}
                            label="PIN"
                        />
                        <LabeledString
                            className="customer-contribution"
                            data={buildDate(this.props.duplicatePlate.dateSubmmited)}
                            label="DATE_SUBMITTED"
                        />
                    </div>
                    <div className="row">
                        <LabeledString
                            className="status-value"
                            data={this.props.duplicatePlate.status}
                            label="STATUS"
                        />
                        <LabeledString
                            className="tcsm-requester"
                            data={this.props.duplicatePlate.requesterTCSM}
                            label="REQUESTER_TCSM"
                        />
                        <LabeledString
                            className="dealer-contribution"
                            data={this.props.duplicatePlate.mailingRecipient}
                            label="RECIPIENT_MAILING"
                        />
                    </div>
                    <div className="row">
                        <LabeledString
                            className="responsible-dealer"
                            data={buildDealer(this.props.duplicatePlate.dealer)}
                            label="RESPONSIBLE_DEALER"
                        />
                        <LabeledString
                            className="factory-code"
                            data={this.props.duplicatePlate.factory}
                            label="FACTORY"
                        />
                    </div>
                    <div className="row">
                        <LabeledString
                            className="created-by"
                            data={this.props.duplicatePlate.createdBy}
                            label="CREATED_BY"
                        />
                        <LabeledString
                            className="reason-missing-plate"
                            data={this.props.duplicatePlate.missingPlateReason}
                            label="REASON_FOR_MISSING_PLATE"
                        />
                    </div>
                    <div className="row">
                        <Attachments
                            files={this.props.duplicatePlate.file}
                            auth={this.props.auth}
                        />
                    </div>

                    <footer>
                        <section className="button-group">
                            {this.props.duplicatePlate.status === 'PENDING' && (
                                <button
                                    className="primary"
                                    onClick={this.handleComplete}
                                >
                                    <FormattedMessage id="SUBMIT" />
                                </button>
                            )}
                            {this.props.duplicatePlate.status === 'PENDING' && (
                                <button
                                    className="secondary"
                                    onClick={this.handleDecline}
                                >
                                    <FormattedMessage id="REJECT" />
                                </button>
                            )}
                            {this.props.duplicatePlate.status === 'PENDING' && (
                                <button
                                    className="secondary"
                                    onClick={this.handleAccept}
                                >
                                    <FormattedMessage id="RETURN" />
                                </button>
                            )}
                        </section>
                    </footer>

                </div>
            </section>
        );

    }

}

DuplicatePinPlateResult.displayName = 'DuplicatePinPlateResult';
DuplicatePinPlateResult.propTypes = {
    actions: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    duplicatePlate: PropTypes.instanceOf(DuplicatePinPlateView).isRequired,
};

export default DuplicatePinPlateResult;
